/**
 * Marker for "this request failed because the session expired".
 *
 * The 401 response interceptor used to return a promise that NEVER settled, so
 * that no caller's `catch` could fire a toast for an auth expiry - the
 * session-expired screen (SessionExpiredGate) is the single UX entry point for that. The cost was that
 * a never-settling promise is unobservable by construction: `finally` never
 * runs, so any component that flipped a loading flag before the call sat on a
 * spinner (or a blank box) forever, and nothing was reported to Sentry.
 *
 * The interceptor now REJECTS with an error carrying this marker instead.
 * Callers get their `catch`/`finally` back - they can clear loading state and
 * render something - while `isAuthExpiredError(err)` tells them to stay silent
 * and leave the modal to do the talking.
 */
export const AUTH_EXPIRED = Symbol.for("app.authExpired");

export const createAuthExpiredError = (originalError, message = "Session expired") => {
  const error = originalError instanceof Error ? originalError : new Error(message);
  error[AUTH_EXPIRED] = true;
  error.isAuthExpired = true;
  return error;
};

export const isAuthExpiredError = error => Boolean(error && (error[AUTH_EXPIRED] || error.isAuthExpired));
